import React from 'react';
import { bool } from 'prop-types';
import {
  Skeleton,
  SkeletonBlock,
  SkeletonLine,
  SkeletonContent
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';

const SkeletonCollectionCard = ({ isMobile }) => {
  const cardContainerClasses = classNames(
    'sui-paper sui-paper-outlined sui-rounded-base sui-flex sui-rounded-md sui-overflow-hidden sui-p-4 sui-gap-4',
    isMobile ? 'sui-flex-col min-[430px]:sui-flex-row' : ''
  );

  const cardMediaClasses = classNames(
    'sui-flex',
    isMobile && [
      'sui-justify-center',
      'sui-flex-col',
      'sui-items-center',
      'min-[430px]:sui-w-[170px]',
      'sui-h-[170px]',
      'sui-shrink-0',
      'sui-overflow-hidden'
    ].join(' '),
    !isMobile && 'sui-basis-2/5'
  );

  return (
    <div className={cardContainerClasses}>
      {/* Image Skeleton */}
      <div className={cardMediaClasses}>
        <Skeleton disablePadding grow>
          <SkeletonBlock aspect="square" />
        </Skeleton>
      </div>

      {/* Content Skeleton */}
      <div className="sui-flex sui-basis-3/5 sui-flex-col sui-gap-2">
        {/* Title and Brand */}
        <SkeletonContent disablePadding>
          <SkeletonLine variant="heading" />
          <SkeletonLine variant="text" width="60%" />
        </SkeletonContent>

        {/* Promotion area */}
        <SkeletonContent disablePadding>
          <SkeletonLine variant="text" width="80%" />
        </SkeletonContent>

        {/* Price */}
        <SkeletonContent disablePadding>
          <SkeletonLine variant="heading" width="40%" />
        </SkeletonContent>

        {/* Buttons */}
        <div className="sui-flex sui-gap-2 sui-mt-auto">
          <Skeleton disablePadding grow>
            <SkeletonBlock height="36px" />
          </Skeleton>
          <Skeleton disablePadding grow>
            <SkeletonBlock height="36px" />
          </Skeleton>
        </div>
      </div>
    </div>
  );
};

SkeletonCollectionCard.propTypes = {
  isMobile: bool
};

SkeletonCollectionCard.defaultProps = {
  isMobile: false
};

export default SkeletonCollectionCard;